import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { store } from "@/shared/services/store";
import { SentryService } from "@/shared/services/sentry/sentry.service";
import { AppIntlProvider } from "@/i18n";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./index.css";

SentryService.init();

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <AppIntlProvider>
      <StrictMode>
        <App />
      </StrictMode>
    </AppIntlProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
